import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  transactionsTable: {
    position: 'relative',
    '& + &': {
      marginTop: '68px',
      '&:before': {
        content: '""',
        height: '40px',
        borderRight: "4px dashed ".concat(palette.shades[500]),
        display: 'inline-block',
        position: 'absolute',
        top: '-68px',
        left: '98px',
        margin: '10px 0',
        [breakpointsFunc.breakpoints.down('md')]: {
          left: '46px'
        }
      }
    }
  },
  summaryCell: {
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  mediumCell: {
    width: '200px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: 'initial'
    }
  },
  smallCell: {
    width: '150px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      width: 'initial'
    }
  },
  transactionAmount: {
    verticalAlign: 'middle',
    display: 'inline-block',
    marginLeft: '10px'
  },
  xsmallCell: {
    width: '80px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: 'initial'
    }
  },
  hideTablet: {
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  showTablet: {
    display: 'none',
    [breakpointsFunc.breakpoints.down('md')]: {
      display: 'inline-block'
    }
  },
  transactionTime: {
    [breakpointsFunc.breakpoints.down('md')]: {
      fontWeight: '600'
    }
  },
  summary: {
    display: 'inline-block',
    marginLeft: '14px'
  },
  periodCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    maxWidth: '350px',
    textOverflow: 'ellipsis'
  }
});
export default useStyles;